import { cn } from '@dreamtree-org/twreact-ui';

/**
 * The page chrome every routed screen sits in — gutters, reading-width cap, and the
 * scroll container. DefaultLayout deliberately owns none of these: it hands its child
 * a bounded flex column and the shell decides what to do with it, so a canvas screen
 * can opt out of all three with `bleed` instead of guessing its height from the viewport.
 *
 * `bleed` screens must not scroll here — they distribute the height to their own panels,
 * each of which scrolls internally.
 */
export default function PageShell({ bleed = false, width = 'default', className, children }) {
  if (bleed) {
    return (
      <div className={cn('flex-1 min-h-0 flex flex-col overflow-hidden pb-safe-nav md:pb-0', className)}>
        {children}
      </div>
    );
  }
  // Scrolling happens on the full-width track so the scrollbar stays at the window edge;
  // the cap and gutters live on the inner box.
  return (
    <div className="flex-1 overflow-y-auto pb-safe-nav md:pb-0">
      <div
        className={cn(
          'mx-auto w-full px-3 sm:px-4 lg:px-6 py-3 sm:py-4',
          width === 'narrow' ? 'max-w-3xl' : 'max-w-screen-2xl',
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}
